import React from "react";
import Layout from "@/locales/en/layout/Layout";
import CustomTitle from "@/components/custom_title";
import {useTranslation} from "react-i18next";
import img from "./img.png"

function Study_in_Uzbekistan() {
    const {t} = useTranslation();

    return (
        <Layout>
            <CustomTitle
                name={t("header.header__bottom__nav__item__menu.menu-6.item-6")}
            />
            <div className="container">
                <img src={img} className="w-50" alt=""/>
                <div dangerouslySetInnerHTML={{__html: t("Study_in_Uzbekistan")}}/>
                <a className="btn btn-primary mt-3" href="https://studyin-uzbekistan.uz/universities/100"
                   target="_blank" rel="noopener noreferrer">
                    https://studyin-uzbekistan.uz/universities/100
                </a>

            </div>
        </Layout>
    );
}

export default Study_in_Uzbekistan;
